<template>
  <v-col class="pa-0">
    <v-row class="ma-0 pa-0">
      <v-col align="center" cols="8" offset="2">
        <h2>{{ $translate('RESET_EMAIL_TITLE') }}</h2>
      </v-col>
      <v-col class="text-right">
        <v-icon size="20" @click="onCloseBtnClick"> ti-close </v-icon>
      </v-col>
    </v-row>

    <!-- Text to display after Email is changed -->
    <v-row v-if="emailChanged" class="mx-3 my-0">
      <v-col align="center">
        <v-icon size="140" color="#a7dc86"> done_outline </v-icon>
        <p class="mt-2">{{ $translate('EMAIL_CHANGED_DESC') }}</p>
      </v-col>
    </v-row>

    <v-form v-else v-model="valid" ref="form" lazy-validation>
      <v-row class="mx-3 my-0">
        <!-- New Email -->
        <v-col cols="12" class="pt-2 pb-0">
          <v-text-field
            v-model="newEmail"
            :rules="emailRules"
            :label="$translate('NEW_EMAIL')"
            outlined
            required
            hide-details="auto"
          />
        </v-col>
        <!-- Confirm new email -->
        <v-col cols="12" class="pt-2 pb-0">
          <v-text-field
            v-model="newEmailConfirm"
            :rules="emailRules"
            :label="$translate('CONFIRM_NEW_EMAIL')"
            outlined
            required
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12">
          <v-alert
            v-if="errorMessage !== ''"
            color="red"
            dense
            text
            type="error"
            >{{ errorMessage }}</v-alert
          >
          <v-btn
            color="primary"
            depressed
            block
            large
            class="pt-1 primary-font-color"
            @click="changeEmail"
            :loading="loading"
          >
            {{ saveBtnText }}
          </v-btn>
        </v-col>
        <v-divider />
      </v-row>
    </v-form>

    <v-dialog
      v-model="showChangeEmailSuccessMessage"
      max-width="400px"
      class="rounded-lg"
      transition="scroll-y-reverse-transition"
      persistent
    >
      <v-card v-if="showChangeEmailSuccessMessage" class="pa-0">
        <ChangeEmailSuccess @close="showChangeEmailSuccessMessage = false" />
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import doRequest from '@/api/dssRequest';
import UserObject from '@/objects/UserObject';
import ChangeEmailSuccess from '@/components/account/AccountChangeEmailSuccess';

export default {
  name: 'AccountChangeEmail',
  components: {
    ChangeEmailSuccess,
  },
  computed: {
    userLoggedin() {
      const isAuthenticated = this.$store.getters['auth/isValid'];
      if (isAuthenticated) {
        return true;
      }
      return false;
    },
    saveBtnText() {
      if (this.userLoggedin) {
        return this.$translate('SAVE');
      }
    },
  },
  data() {
    return {
      oldEmail: '',
      newEmail: '',
      newEmailConfirm: '',
      emailRules: [
        (v) => !!v || this.$translate('EMAIL_REQUIRED'),
        (v) => /.+@.+\..+/.test(v) || this.$translate('EMAIL_VALID'),
      ],
      loading: false,
      valid: null,
      errorMessage: '',
      userIdNoLogin: '',
      emailChanged: false,
      showChangeEmailSuccessMessage: false,
    };
  },
  methods: {
    changeEmail() {
      // Request an email with a link to reset the account with new email
      if (this.$refs.form.validate()) {
        this.loading = true;

        const payload = {
          NewEmail: this.newEmail,
        };
        let ObjectId = this.$store.getters['auth/userName'];

        if (this.userLoggedin) {
          payload.UserId = this.$store.getters['auth/userName'];
        }

        doRequest(
          this.onChangeEmailSucceed,
          this.onChangeEmailFail,
          'resetEmail',
          ObjectId,
          payload
        );
      } else {
        window.EventBus.fire('activateSnackBar', {
          text: this.$translate('LINDA_FILL_REQUIRED'),
          color: 'warning',
        });
      }
    },

    onChangeEmailSucceed(response) {
      this.loading = false;
      this.$emit('close');
      this.showChangeEmailSuccessMessage = true;
      // logout the current user
      UserObject.logout();
    },
    onChangeEmailFail(error) {
      this.loading = false;
      this.errorMessage = this.$translateError(error.data.ErrorCode);
    },
    onCloseBtnClick() {
      this.$emit('close');
    },
  },
};
</script>
